import React from "react";
type FieldProps = {
  id: string;
  label: string;
  error?: string;
  optional?: boolean;
  children: React.ReactNode;
};
export function Field({
  id,
  label,
  error,
  optional,
  children
}: FieldProps) {
  return <div data-id="element-56" data-mp="a21aerxnt7ls">
      <label htmlFor={id} className="mb-2 block text-sm font-medium text-navy" data-id="element-57" data-mp="a1szv6p0eedr">
        {label}
        {optional && <span className="font-normal text-navy-soft" data-id="element-58" data-mp="53hrz1i9ydy6"> (facultatif)</span>}
      </label>
      {children}
      {error && <p id={`${id}-error`} className="mt-1.5 text-sm text-red" data-id="element-59" data-mp="11u0gi74ilqs5">
          {error}
        </p>}
    </div>;
}